// @ts-nocheck





import { fetchRequest, initialFetchListParams } from './index';


export const addMaintenanceOperation = async (
maintenanceOperation) =>
{
  const added = await fetchRequest.post(
    '/maintenanceOperation',
    maintenanceOperation
  );
  if (added) return added;
  throw new Error('Не удалось создать вид работы');
};

export const updateMaintenanceOperation = async (
maintenanceOperation) =>
{
  const updated = await fetchRequest.put(
    '/maintenanceOperation',
    maintenanceOperation
  );
  if (updated) return updated;
  throw new Error('Не удалось обновить вид работы');
};

export const fetchMaintenanceOperation = async (
id,
params = {}) =>

await fetchRequest.get(`/maintenanceOperation/${id}`, params);

export const deleteMaintenanceOperation = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/maintenanceOperation/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить вид работы');
};

export const fetchMaintenanceOperations = async (
params = initialFetchListParams) =>

await fetchRequest.get('/maintenanceOperation', {
  ...initialFetchListParams,
  ...params
});

export default {
  addMaintenanceOperation,
  fetchMaintenanceOperation,
  updateMaintenanceOperation,
  deleteMaintenanceOperation,
  fetchMaintenanceOperations
};
